/**
 * API Route Registry
 * Centralized constants for all API endpoints
 * 2026 Enterprise Standard: Single source of truth for API paths
 */

export const API_ROUTES = {
    // Recipes endpoints
    RECIPES: {
        BASE: 'recipes',
        DETAIL: (id: string) => `recipes/${id}`,
        CLONE: (id: string) => `recipes/${id}/clone`,
        CLEAR_AI: (id: string) => `recipes/${id}/clear-ai`,
        CLEAR_ALL_METADATA: (id: string) => `recipes/${id}/clear-all-metadata`,

        SEARCH: 'recipes/search',
        ANALYZE: 'recipes/analyze',
        BATCH_CATEGORIES: 'recipes/batch-categories',
        BATCH_DELETE: 'recipes/batch/delete',
        BATCH_EXPORT_PDF: 'recipes/export/pdf',
        BATCH_EXPORT_JSON_LD: 'recipes/export/json-ld',
    },

    // Categories endpoints
    CATEGORIES: {
        BASE: 'categories',
        DETAIL: (id: string) => `categories/${id}`,
    },

    // Workspaces endpoints
    WORKSPACES: {
        BASE: 'workspaces',
        DETAIL: (id: string) => `workspaces/${id}`,
        HYDRATE: (id: string) => `workspaces/${id}/hydrate`,
        RECIPES: (id: string) => `workspaces/${id}/recipes`,
        LINK_RECIPE: (workspaceId: string, recipeId: string) =>
            `workspaces/${workspaceId}/recipes/${recipeId}`,
        MEMBERS: (id: string) => `workspaces/${id}/members`,
        LEAVE: (id: string) => `workspaces/${id}/leave`,
    },

    // Authentication endpoints
    AUTH: {
        ME: 'auth/me',
        LOGOUT: 'auth/logout',
    },

    // Import/Scraping endpoints
    IMPORT: {
        SCRAPE: 'import/scrape',
        PARSE: 'import/parse',
    },

    // Nutrition endpoints
    NUTRITION: {
        ANALYZE: 'nutrition/analyze',
    },

    // Units endpoints
    UNITS: {
        STANDARD: 'units/standard',
    },
} as const;

